import React, { useEffect, useState } from "react";
import Paywall from "../Paywall/Paywall";
import { usePaywallStateDispatch } from "../Paywall/PaywallContext";
import TrialEndModal from "../TrialEndModal/TrialEndModal";
import DiscordInsightsPage from "./DiscordInsightsPage";
import SlackInsightsPage from "./SlackInsightsPage.jsx";

const Insights = () => {
  const platform = localStorage.getItem("platform");
  const { loadingPlanTier, userPlanTier, trialing } = usePaywallStateDispatch();

  useEffect(() => {
    document.title = "Insights | Dots";
  }, []);

  return (
    <div>
      {platform === "slack" ? (
        <SlackInsightsPage />
      ) : (
        <Paywall
          free={<TrialEndModal imagePreview="insights-preview" />}
          pro={
            trialing ? (
              <DiscordInsightsPage />
            ) : (
              <TrialEndModal
                title="Insights page is only available on Business plan"
                showFreePagesMsg={false}
                imagePreview="insights-preview"
              />
            )
          }
          business={<DiscordInsightsPage />}
          tier={userPlanTier}
          loading={loadingPlanTier}
        />
      )}
    </div>
  );
};

export default Insights;
